module.exports = __webpack_public_path__ + "img/kaffeemaschine.c7b8270f.jpg";